import { ComputationFrequency } from "../../requests_cm/gecoContractsService/types";

export const rollConventionOptions: Record<ComputationFrequency, { label: string; value: string }[]> = {
    [ComputationFrequency.MONTHLY]: [{ label: "EOM", value: "EOM" }],
    [ComputationFrequency.BIMONTHLY]: [{ label: "None", value: "None" }],
    [ComputationFrequency.WEEKLY]: [
        { label: "SUN", value: "SUN" },
        { label: "MON", value: "MON" },
        { label: "TUE", value: "TUE" },
        { label: "WED", value: "WED" },
        { label: "THU", value: "THU" },
        { label: "FRI", value: "FRI" },
        { label: "SAT", value: "SAT" },
        { label: "NONE", value: "NONE" },
    ],
};